import create from "zustand";
import { devtools, persist } from "zustand/middleware";

let state = (set) => ({
  langCd: '',
  nationCd: '',
  isPC: '',
  setLangCd: (data) => set(() => ({ langCd: data })),
  setNationCd: (data) => set(() => ({ nationCd: data })),
  setIsPC: (data) => set(() => ({ isPC: data })),
});

const useCommonStore = create(devtools(state));

export default useCommonStore;